<script>
  // Stores
  import { editContactStore } from "../stores";
  // Components
  import ConfirmNavigation from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/ConfirmNavigation.svelte";

  export let confirm = () => {};
  export let cancel = () => {};

  const editContactDirty = editContactStore.dirty;
</script>

<ConfirmNavigation {confirm} {cancel}>
  <div slot="header">
    <h2>Discard unsaved changes</h2>
  </div>
  You have unsaved changes {$editContactDirty
    ? "to this profile"
    : "to your step"}.
  <br />
  Would you like to discard these changes?
</ConfirmNavigation>
